// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"gQ-z","inlineTitle":"hQ-z","sponsoredAdsWrapper":"iQ-z","marketplaceRecosWrapper":"jQ-z"};